'use client';

import { useEffect, useState } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

export default function Header() {
  const pathname = usePathname();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navLinks = [
    { href: '/', label: 'home' },
    { href: '/about', label: 'about' },
    { href: '/members', label: 'members' },
  ];

  return (
    <>
      <header id="header" className={`fixed-top${scrolled ? ' header-scrolled' : ''}`}>
        <div className="container d-flex align-items-center justify-content-center">
          <nav className="nav-menu" aria-label="Main Navigation">
            <ul>
              {navLinks.map(({ href, label }) => (
                <li key={href} className={pathname === href ? 'active' : ''}>
                  <Link href={href} aria-current={pathname === href ? 'page' : undefined}>{label}</Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </header>
    </>
  );
}
